import { useNavigate } from 'react-router-dom';

import Button from '@/components/ui/buttons/Button';
import Modal from '@/components/ui/modals/Modal';
import useFetch from '@/hooks/common/useFetch';
import useModal, { type ModalInnerProps } from '@/hooks/common/useModal';
import useToast from '@/hooks/store/useToast';

import styles from './AbsencesCancelModal.module.scss';

interface Props extends ModalInnerProps {
  absenceId: string;
  contactType: string;
  organizationMembershipId: string;
}

const AbsencesCancelModal: React.FC<Props> = ({
  isOpen,
  toggle,
  absenceId,
  contactType,
  organizationMembershipId,
}) => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { showModal } = useModal();
  const { fetch: fetchCancel, isFetching } = useFetch(
    'PUT',
    `/api/school_communication/absences/${absenceId}/${contactType}`,
  );

  const handleOnClick = async () => {
    const res = await fetchCancel();
    const { status } = res;

    if (status === 200) {
      navigate(`/absences/member/${organizationMembershipId}`);
      toggle();
      showModal('AbsencesCanceledModal', {});
    } else {
      showToast('欠席連絡の申請が取り消しできませんでした。');
      toggle();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      title={'本当に申請を取り消しますか？'}
    >
      <div className={styles.description}>
        この操作は取り消せません。本当に申請を取り消してもよろしいですか？
      </div>
      <div className={styles.buttons}>
        <Button
          size="s"
          color="outline"
          onClick={toggle}
          className={styles.button}
        >
          キャンセル
        </Button>
        <Button
          size="s"
          color="danger"
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onClick={handleOnClick}
          disabled={isFetching}
          className={styles.button}
        >
          取り消し
        </Button>
      </div>
    </Modal>
  );
};

export default AbsencesCancelModal;
